import "core-js/modules/esnext.global-this.js";
import "core-js/modules/esnext.global-this.js";
import { useEffect } from 'react';
import mitt from 'mitt';
/*! @carvana/core-events v1.0.8 - Mon Oct 09 2023 22:18:00 GMT+0000 (Coordinated Universal Time) */

var eventNames = {
  accountModal: {
    open: "ACCOUNT_MODAL_OPEN",
    close: "ACCOUNT_MODAL_CLOSE",
    userLoggedIn: "ACCOUNT_MODAL_LOGIN_COMPLETE",
    userLoggedOut: "ACCOUNT_MODAL_LOGOUT_COMPLETE",
    userError: "ACCOUNT_MODAL_USER_ERROR",
    user: {
      error: "ACCOUNT_MODAL_USER_ERROR",
      loggedIn: "ACCOUNT_MODAL_LOGIN_COMPLETE",
      loggedOut: "ACCOUNT_MODAL_LOGOUT_COMPLETE"
    }
  },
  supportDropDown: {
    open: "SDD_OPEN",
    close: "SDD_CLOSE"
  },
  favorites: {
    add: "FAVORITES_ADD",
    remove: "FAVORITES_REMOVE",
    refresh: "FAVORITES_REFRESH",
    drawer: {
      open: "FAVORITES_DRAWER_OPEN",
      close: "FAVORITES_DRAWER_CLOSE"
    },
    vehicle: {
      removed: "FAVORITES_VEHICLE_REMOVED"
    }
  },
  auth: {
    change: "USER_CHANGE",
    login: "USER_LOGIN",
    logout: "USER_LOGOUT",
    refresh: "USER_REFRESH",
    tokenRefreshed: "USER_TOKEN_REFRESHED",
    userLoggedOut: "USER_LOGGED_OUT"
  },
  leadCapture: {
    modal: {
      open: "LEAD_CAPTURE_MODAL_OPEN",
      closed: "LEAD_CAPTURE_MODAL_CLOSED"
    },
    success: "LEAD_CAPTURE_SUCCESS",
    failure: "LEAD_CAPTURE_FAILURE"
  },
  toasts: {
    addToast: "ADD_TOAST",
    removeToast: "REMOVE_TOAST"
  },
  header: {
    refreshProfile: "HEADER_REFRESH_PROFILE",
    drawer: {
      open: "HEADER_DRAWER_OPEN",
      close: "HEADER_DRAWER_CLOSE"
    }
  }
};

var CarvanaEvents = function CarvanaEvents() {
  return globalThis["CarvanaEvents"];
};

var getName = function getName(name) {
  return name ? "(" + name + ")" : "";
};

var EventEmitter = function EventEmitter() {
  var allEvents = new Map();
  var queue = new Map();
  var history = new Map();

  var _ref = CarvanaEvents() || {},
      emitter = _ref.emitter;

  var mittInstance = emitter || mitt && mitt(allEvents);

  if (!emitter) {
    globalThis["CarvanaEvents"] = Object.assign({}, CarvanaEvents(), {
      emitter: mittInstance
    });
  }

  var listenOnceSubscribers = new Set();

  var emit = function emit(type, event, _temp) {
    var _ref2 = _temp === void 0 ? {
      debug: function (_a) {
        return (_a = CarvanaEvents()) == null ? void 0 : _a.debug;
      }()
    } : _temp,
        debug = _ref2.debug,
        name = _ref2.name;

    if (debug) {
      console.log("[CarvanaEvents" + getName(name) + "]: sending event to: " + type, event);
    }

    if (type !== "*") history.set(type, event);

    if (!mittInstance.all.has(type) && !mittInstance.all.has("*")) {
      queue.set(type, event);
      return;
    }

    mittInstance.emit(type, event);
  };

  var on = function on(type, handler, _temp2) {
    var _ref3 = _temp2 === void 0 ? {
      withHistory: false,
      debug: function (_b) {
        return (_b = CarvanaEvents()) == null ? void 0 : _b.debug;
      }(),
      listenOnce: false
    } : _temp2,
        withHistory = _ref3.withHistory,
        debug = _ref3.debug,
        name = _ref3.name,
        listenOnce = _ref3.listenOnce;

    if (debug) {
      console.log("[CarvanaEvents" + getName(name) + "]: listening for " + type, handler);
    }

    if (listenOnce && !listenOnceSubscribers.has(type) || !listenOnce) {
      listenOnceSubscribers.add(type);
      mittInstance.on(type, handler);
    }

    if (type !== "*" && queue.has(type)) {
      queue.forEach(function (fn) {
        mittInstance.emit(type, fn);
      });
      queue.delete(type);
    }

    if (withHistory && history.has(type)) {
      mittInstance.emit(type, history.get(type));
    }
  };

  var off = function off(type, handler, _temp3) {
    var _ref4 = _temp3 === void 0 ? {
      debug: function (_c) {
        return (_c = CarvanaEvents()) == null ? void 0 : _c.debug;
      }()
    } : _temp3,
        debug = _ref4.debug,
        name = _ref4.name;

    if (debug) {
      console.log("[CarvanaEvents" + getName(name) + "]: stopping " + type, handler);
    }

    mittInstance.off(type, handler);
  };

  return Object.assign({}, mittInstance, {
    emit: emit,
    on: on,
    emitWithType: emit,
    onWithType: on,
    once: function once(type, handler, opts) {
      var fn = function fn() {
        mittInstance.off(type, fn);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        handler(args);
      };

      on(type, fn, opts);
    },
    off: off
  });
};

var EventInstance = /*#__PURE__*/function () {
  function EventInstance() {
    return EventEmitter();
  }

  EventInstance.getInstance = function getInstance() {
    if (!EventInstance.instance) {
      EventInstance.instance = new EventInstance();
    }

    return EventInstance.instance;
  };

  return EventInstance;
}();

var CoreEvent = EventInstance.getInstance();

var useCoreEvents = function useCoreEvents(eventName, handler, opts) {
  useEffect(function () {
    if (!eventName || !handler) return function () {};
    CoreEvent.on(eventName, handler, opts);
    return function () {
      CoreEvent.off(eventName, handler, opts);
    };
  }, [eventName, handler, opts]);
  return CoreEvent;
};

var useCoreEvents_default = useCoreEvents;
export { CoreEvent, eventNames, useCoreEvents_default as useCoreEvents };